function init_inspiratie_grid() {
    var $inspiratie_grid = $('.js-inspiratie-grid');

    if(!$inspiratie_grid.length) {
        return;
    }

    $inspiratie_grid.masonry({
        itemSelector: '.inspiratie-grid__item',
        percentPosition: true,
        columnWidth: '.grid-sizer'
    });

    var $load_more_button = $inspiratie_grid.next('.inspiratie-grid__load-more').find('.js-inspiratie-grid-load-more');

    // Load and append nexts items
    $load_more_button.on('click', function() {
        $load_more_button.attr('disabled', true);

        var current_post_count = $inspiratie_grid.attr('data-current-loaded');

        $.ajax({
            type: "POST",
            url: cpx_ajax_url,
            data: {
                action: 'get_next_inspiratie_grid_items',
                current_post_count: current_post_count
            },
            success:function(response) {
                response = JSON.parse(response);

                // We use this to determine if we need to hide the load more button
                var step_size = $inspiratie_grid.attr('data-step-size');
                var recieved_item_count = response['items'].length;

                // Append the items to the grid
                var inserted_html = '';
                for(i=0;i<response['items'].length;i++) {
                    inserted_html += '<a class="inspiratie-grid__item is-loading" href="'+response['items'][i]['url']+'"><img src="'+response['items'][i]['img']+'"></a>';
                }

                // Change the current count of posts
                var new_post_count = (parseInt(current_post_count, 10) + parseInt(recieved_item_count, 10));
                $inspiratie_grid.attr('data-current-loaded', new_post_count);

                // If this is the last page
                if(response['page'] == response['max_page_size']) {
                    $load_more_button.fadeOut();
                }
                // If not the last page, enable the button
                else {
                    $load_more_button.attr('disabled', false);
                }

                // Reload the masonry grid
                var $content = $(inserted_html);
                $inspiratie_grid.append($content);

                setTimeout(function() {
                    $inspiratie_grid.masonry('appended', $content);

                    $loading_items = $inspiratie_grid.find('.is-loading');
                    $loading_items.removeClass('is-loading');

                }, 100);
            },
            error: function(error){
                console.log(error);
            }
        });
    });
}

$(document).ready(function() {
    init_inspiratie_grid();
});